<template lang="html">
  <div class="divider" :class="theClass">
    <span v-if="$slots.default">
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    line: Boolean,
    size: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    theClass() {
      let value = 'size-' + this.size;
      if (this.line) {
        value += ' line';
      }
      return value;
    },
  },
};
</script>

<style lang="scss">
.divider {
  height: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &.line {
    &:before,
    &:after {
      content: '';
      height: auto;
      background-color: rgba(black, 0.1);
      width: 100%;
      height: 1px;
    }
    span {
      text-align: center;
      margin: 0 14px;
      display: flex;
      align-items: center;
      white-space: nowrap;
    }
  }

  @for $i from 1 through 4 {
    &.size-#{$i} {
      height: (size($i) * 2);
    }
  }
  // &.size-0 {height: 0}
  // &.size-1 {height: (size(1)*2)}
  // &.size-2 {height: (size(2)*2)}
  // &.size-3 {height: (size(3)*2)}
  // &.size-4 {height: (size(4)*2)}
  // &.size-5 {height: (size(5)*2)}
}
</style>



// WEBPACK FOOTER //
// src/parts/components/divider.vue